export default __webpack_public_path__ + "static/media/gorilla.94da1ebc.png";